import { useEffect } from "react";

const BASE = "AV Contracting";
const DEFAULT = "Amazing View Contracting | Excavation & Concrete BC"; // 51 chars
const DEFAULT_DESC = "Amazing View Contracting — excavation, concrete, drainage and site work serving Vancouver Island and the Lower Mainland from Langford, BC. Free written estimates.";
const CANONICAL_BASE = "https://www.amazingviewcontracting.com";
const MAX_TITLE = 60;

export function usePageTitle(title, description) {
  useEffect(() => {
    let full = DEFAULT;
    if (title) {
      let t = title.trim();
      const max = MAX_TITLE - (BASE.length + 3);
      if (t.length > max) t = `${t.slice(0, max - 1).trimEnd()}…`;
      full = `${t} · ${BASE}`;
    }
    document.title = full;

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${CANONICAL_BASE}${window.location.pathname}`);

    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", description || DEFAULT_DESC);

    return () => {
      document.title = DEFAULT;
      if (meta) meta.setAttribute("content", DEFAULT_DESC);
    };
  }, [title, description]);
}
